import MainButton from './MainButton';

export default MainButton;
